

var FileSaver = require('file-saver');

/**
 *
 * @param countryName
 * @returns {{flag: string, lat: number, long: number}}
 */
import newcoordinates from '../_config/ressources/clean_countries_byFrenchName_centroid'

export const getCountryLatLongFlag = (countryName)=>{
    let dataCountryForMap = {};
        dataCountryForMap = {
            coordinates: [
                newcoordinates[countryName.toUpperCase()] ? newcoordinates[countryName.toUpperCase()].latitude : "-",
                newcoordinates[countryName.toUpperCase()] ? newcoordinates[countryName.toUpperCase()].longitude : "-" ,
            ],
            flag : newcoordinates[countryName.toUpperCase()] ?  newcoordinates[countryName.toUpperCase()].flag : "-",
            countryFr : countryName
        }
    return dataCountryForMap;

}

/**
 * Fonction pour préparer les données et les envoyer à VisualTimeLine
 * @param incomingData: en général sont les données contenues dans les fichiers.json sans traitement
 * @returns {*[]}
 */
//todo reconstruire les données car elle sont mal construites
    //todo régler le problème de la clôture et intoduire la fct stripTitle qui existe dans le fichier RER/Parts/Timeline
export const buildEventsToVisualTimeLine = (incomingData) =>{
        let incomingEvents = [];
        if(incomingData){
            for(let i =0;i<incomingData.length;i++){
                let container = {};
                if( (incomingData[i]["Année de démarrage"] !== null) && (incomingData[i]["Projet"] !== null)){
                    container = {
                        id: i,
                        content: incomingData[i]["Projet"],
                        start: new Date(incomingData[i]["Année de démarrage"]),
                        title: incomingData[i]["Projet"]
                    };

                   /* if(incomingData[i]["Année de clôture"] && incomingData[i]["Année de clôture"] !== null && incomingData[i]["Année de clôture"] !== "" && incomingData[i]["Année de clôture"] !== incomingData[i]["Année de démarrage"]) {
                        container["end"] = new Date(incomingData[i]["Année de clôture"]);
                    }else{
                        container["type"] = "point";
                    }*/
                    incomingEvents.push(container)
                }
            }
        }
        return incomingEvents

}

/**
 * Fonction our vérifier si les éléments d'un tableau sont null , "", undefined
 * @param array
 * type de retour : boolean
 */
export const isAnArrayNull = (anArray) =>{
    let isAnArrayNull = true;
    anArray.forEach((item)=>{

        if( (item !== null) && (item !== "") && (item !== undefined )){
            isAnArrayNull = false
        }
    })
    return isAnArrayNull

}

import domtoimage from 'dom-to-image';
/**
 *
 * @param domElement
 */
export const generateImageFromDOM =(domElement)=>{
    domtoimage.toJpeg(domElement, { quality: 1, bgcolor: "white" })
        .then(function (dataUrl) {
            var link = document.createElement('a');
            link.download = 'my-image-name.jpeg';
            link.href = dataUrl;
            link.click();
        });
}

/**
 * Fonction pour transformer un objet en tableau en vue de son affichage dans un datatable à 2 colonnes
 * @param myObject Object L'objet à transformer
 * @param keys Array les clés d'accès à l'objet dans un certaine ordre
 * @returns {*[]}
 */
export const object2Array = (myObject,keys)=>{
    let result = []
    if(keys){
        keys.forEach((key)=>{
            result.push({
                key: key,
                value: myObject[key]
            })
        })
    }else{
        Object.keys(myObject).forEach((key)=>{
            result.push({
                key: key,
                value: myObject[key]
            })
        })
    }
    return result
};
/**
 * Fonction pour extraires des clés spécéfiques d'un objet
 * @param itemObject Object l'objet initial
 * @param keys arrau le tableau des clés à extraire
 * @returns {{ un objet avec les clés et les valeurs qu'on veut}}
 */
export const selectKeys = (itemObject,keys) =>{
    let result = {};
    keys.forEach((item) =>{
        result = {...result, [item] : itemObject[item]}
    })
    console.log("result",result)
    return result;
}

/**
 * Fonction pour transformer un tableau des objets à un objet constitué de ces objets
 * @param myArray  le tableau d'objets à transformer
 */

    export const arrayOfObjects2object = (myArray) =>{
        return myArray.reduce((obj, item) => (obj[item.key] = item.value, obj) ,{});
    }


/**
 *
 * @param datas
 * @param delimiter
 * @param headers
 * @param columns
 * @returns {string|undefined}
 */
export const arrayData2csvData = (datas,delimiter,headers, columns)=>{
    let options = {
        quotes: false, //or array of booleans
        quoteChar: '"',
        escapeChar: '"',
        delimiter: delimiter ? delimiter : ',',
        header: !headers,
        newline: "\r\n",
        skipEmptyLines: true, //or 'greedy'
    };

    if(columns) options.column = columns;
    let csvDatas = Papa.unparse(datas,options);
    if(headers){
        let  myheaders = headers.map((header)=>{ return header.text})
        csvDatas = myheaders.join(',')+'\n'+csvDatas;
    }
    return csvDatas;
};

export const dataURItoFile = (dataURI,filename)=> {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for(var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    FileSaver.saveAs(new Blob([new Uint8Array(array)], {type: 'image/jpeg'}), filename ? filename : "file.jpg");
}

/**
 *
 * @param content
 * @param filename
 */
export const downloadAsFile = (content, filename)=>{
    let extension = getFileExtension(filename);
    let type = getMimeType(extension);//+';charset=utf-8';
    let blob = new Blob([content], {type:  'text/plain;charset=utf-8' });
    FileSaver.saveAs(blob, filename ? filename : "file.export");
};

export const getFileExtension = (pathOrFilename)=>{
    return pathOrFilename.split('.').pop().toLowerCase();
};

export const getMimeType = (type)=>{
    let mimeTypes = {
        "txt" : "text/plain",
        "htm" : "text/html",
        "html" : "text/html",
        "php" : "text/html",
        "css" : "text/css",
        "js" : "application/javascript",
        "json" : "application/json",
        "xml" : "application/xml",
        "swf" : "application/x-shockwave-flash",
        "flv" : "video/x-flv",
        // images
        "png" : "image/png",
        "jpe" : "image/jpeg",
        "jpeg" : "image/jpeg",
        "jpg" : "image/jpeg",
        "gif" : "image/gif",
        "bmp" : "image/bmp",
        "ico" : "image/vnd.microsoft.icon",
        "tiff" : "image/tiff",
        "tif" : "image/tiff",
        "svg" : "image/svg+xml",
        "svgz" : "image/svg+xml",
        // archives
        "zip" : "application/zip",
        "rar" : "application/x-rar-compressed",
        "exe" : "application/x-msdownload",
        "msi" : "application/x-msdownload",
        "cab" : "application/vnd.ms-cab-compressed",
        // audio/video
        "mp3" : "audio/mpeg",
        "qt" : "video/quicktime",
        "mov" : "video/quicktime",
        // adobe
        "pdf" : "application/pdf",
        "psd" : "image/vnd.adobe.photoshop",
        "ai" : "application/postscript",
        "eps" : "application/postscript",
        "ps" : "application/postscript",
        // ms office
        "doc" : "application/msword",
        "rtf" : "application/rtf",
        "xls" : "application/vnd.ms-excel",
        "ppt" : "application/vnd.ms-powerpoint",
        "docx" : "application/msword",
        "xlsx" : "application/vnd.ms-excel",
        "pptx" : "application/vnd.ms-powerpoint",
        // open office
        "odt" : "application/vnd.oasis.opendocument.text",
        "ods" : "application/vnd.oasis.opendocument.spreadsheet",
    };
    return mimeTypes[type] ? mimeTypes[type] : undefined
};

/**
 *
 * @param priority
 * @returns {string}
 */
export const getPriorityColor = (priority)=>{
    let color = '';
    switch (priority) {
        case 'major':
            color = 'warning';
            break;
        case 'minor':
            color = 'secondary';
            break;
        case 'critical':
            color = 'error';
            break;
        default:
            color = 'primary'
    }
    return color
};

/**
 *
 * @param str
 * @returns {String}
 */
export const translateEnglish2FrenchMonths = function(str){
    let monthsMapping = { January : "Janvier", February: "Février", March: "Mars", April: "Avril", May: "Mai", June: "Juin", July: "Juillet", August: "Août", September: "Septembre", October: "Octobre", November: "Novembre", December: "Décembre" }
    let result = multipleStringReplace(str,monthsMapping)
    return result
};

/**
 *
 * @param str
 * @returns {String}
 */
export const translateEnglish2FrenchDays = function(str){
    let daysMapping = { Monday: "Lundi", "Tuesday": "Mardi", "Wednesday": "Mercredi", "Thursday": "Jeudi", "Friday": "Vendredi", "Saturday": "Samedi", "Sunday": "Dimanche" }
    let result = multipleStringReplace(str,daysMapping)
    return result
};

/**
 *
 * @param str
 * @param keyValueStringObject
 * @returns {String}
 */
export const multipleStringReplace = function (str,keyValueStringObject){
    var re = new RegExp(Object.keys(keyValueStringObject).join("|"),"gi");
    let result = str.replace(re, function(matched){
        return keyValueStringObject[matched];
    });
    return result
};

/**
 *
 * @returns {string}
 */
export const guid = function (){
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

/**
 *
 * @returns {number}
 */
export const uniqueNumber = function(){
    return Date.now() + Math.random()

};

/**
 *
 * @param regex
 * @param text
 * @returns {Array}
 */
export const getAllMatches = function(regex, text) {
    if (regex.constructor !== RegExp) {
        throw new Error('not RegExp');
    }

    let res = [];
    let match = null;

    if (regex.global) {
        while (match = regex.exec(text)) {
            res.push(match);
        }
    }
    else {
        if (match = regex.exec(text)) {
            res.push(match);
        }
    }

    return res;
};

/**
 *
 * @param str
 * @returns {boolean}
 * @constructor
 */
export const IsValidJSONString = function(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const removeDuplicates = function (myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

export const uniqArrayEs6 = (arrArg) => {
    return arrArg.filter((elem, pos, arr) => {
        return arr.indexOf(elem) == pos;
    });
};

export const computeIntHash = (input) =>{
    var hash = 0, len = input.length;
    for (var i = 0; i < len; i++) {
        hash  = ((hash << 5) - hash) + input.charCodeAt(i);
        hash |= 0; // to 32bit integer
    }
    return hash;
};

// based on : https://stackoverflow.com/questions/15523514/find-by-key-deep-in-a-nested-object
export const deepGetObjectfunction =  function(theObject,key) {
    var result = null;
    if(theObject instanceof Array) {
        for(var i = 0; i < theObject.length; i++) {
            result = deepGetObjectfunction(theObject[i],key);
            if (result) {
                break;
            }
        }
    }
    else
    {
        for(var prop in theObject) {
            //console.log(prop + ': ' + theObject[prop]);
            if(prop == key) {
                return theObject[prop];
            }
            if(theObject[prop] instanceof Object || theObject[prop] instanceof Array) {
                result = deepGetObjectfunction(theObject[prop],key);
                if (result) {
                    break;
                }
            }
        }
    }
    return result;
};

export const flattenJSON = (obj, path = '') => {
    if (!(obj instanceof Object)) return {[path.replace(/\.$/g, '')]:obj};

    return Object.keys(obj).reduce((output, key) => {
        return obj instanceof Array ?
            {...output, ...flattenJSON(obj[key], path +  '[' + key + '].')}:
            {...output, ...flattenJSON(obj[key], path + key + '.')};
    }, {});
};

//https://stackoverflow.com/questions/14446511/most-efficient-method-to-groupby-on-an-array-of-objects
export const groupByAttributeName = (items, key) => items.reduce(
    (result, item) => ({
        ...result,
        [item[key]]: [
            ...(result[item[key]] || []),
            item,
        ],
    }),
    {},
);


/**
 * fonction groupby sur tableau d'objets
 * @list Array
 * @keyGetter Function
 */
export const groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

export const dataURItoBlob = (dataURI)=> {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    var byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    var blob = new Blob([ab], {type: mimeString});
    return blob;

}

export const getHTMLElementDimensions = (elem)=> {
    if(elem) {
        var rect = elem.getBoundingClientRect();
        console.log(rect.height);
    }
    return rect;
};

export const formatDateToDisplay = (date, language) => {
    let format = 'en-EN';
    switch (language) {
        case 'fr':
            format = 'fr-FR';
            break;
        default:
            format = 'en-EN';
            break;
    }
    if (date) {
        const dRequestedDeadline = new Date(date);
        return dRequestedDeadline.toLocaleDateString(format);
    }

    return '';
};
